import React from "react";

const SkeletonTable = ({ rows = 12, columns = 7 }) => {
  return (
    <div className="w-full p-4 bg-ui-surface">
      <div className="w-full h-full">
        <table className="min-w-full table-auto">
          <thead>
            <tr>
              {Array(columns)
                .fill("")
                .map((_, index) => (
                  <th key={index} className="py-2">
                    <div className="h-4 bg-ui-border animate-pulse rounded-sm"></div>
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {Array(rows)
              .fill("")
              .map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {Array(columns)
                    .fill("")
                    .map((_, colIndex) => (
                      <td key={colIndex} className="px-4 py-2">
                        <div className="h-3 bg-ui-border rounded-sm animate-pulse"></div>
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SkeletonTable;
